import { defineStore } from 'pinia'
import { ref, computed } from 'vue'

export const useFavoritesStore = defineStore('favorites', () => {
  // State
  const favorites = ref(new Set())
  
  // Initialize from localStorage
  const initFavorites = () => {
    try {
      const stored = localStorage.getItem('favorite_games')
      if (stored) {
        const parsed = JSON.parse(stored)
        favorites.value = new Set(parsed)
      }
    } catch (e) {
      console.error('Error loading favorites:', e)
    }
  }
  
  // Save to localStorage
  const saveFavorites = () => {
    try {
      localStorage.setItem('favorite_games', JSON.stringify([...favorites.value]))
    } catch (e) {
      console.error('Error saving favorites:', e)
    }
  }
  
  // Actions
  const toggleFavorite = (gameId) => {
    if (favorites.value.has(gameId)) {
      favorites.value.delete(gameId)
    } else {
      favorites.value.add(gameId)
    }
    saveFavorites()
    return favorites.value.has(gameId)
  }
  
  const addToFavorites = (gameId) => {
    favorites.value.add(gameId)
    saveFavorites()
  }
  
  const removeFromFavorites = (gameId) => {
    favorites.value.delete(gameId)
    saveFavorites()
  }
  
  const isFavorite = (gameId) => {
    return favorites.value.has(gameId)
  }
  
  const clearFavorites = () => {
    favorites.value.clear()
    saveFavorites()
  }
  
  // Getters
  const favoriteCount = computed(() => favorites.value.size)
  
  const favoriteGameIds = computed(() => [...favorites.value])
  
  // Initialize on store creation
  initFavorites()
  
  return {
    favorites,
    favoriteCount,
    favoriteGameIds,
    toggleFavorite,
    addToFavorites,
    removeFromFavorites,
    isFavorite,
    clearFavorites
  }
})
